/** Unified inventory, batch & expiration management — mirrors
 * `backend/app/models/inventory.py` (§6.3). */
import { Money } from "../decimal.js";
export function classifyStockLevel(currentStock, lowStockThreshold) {
    // Decimal comparisons throughout — never `Number(...)` on a money/quantity field
    // (see decimal.ts's file-level doc comment on why).
    if (Money.compare(currentStock, "0") <= 0)
        return "DEPLETED";
    if (Money.compare(currentStock, lowStockThreshold) <= 0)
        return "LOW";
    return "OK";
}
//# sourceMappingURL=inventory.js.map